// src/pages/LoginPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/authSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";
import { MdLocationOn, MdComputer, MdVisibility, MdVisibilityOff } from "react-icons/md";

function LoginPage() {
  const dispatch = useDispatch();
  const { user, isInstalled, loading, error, loginAttempts } = useSelector(
    (state) => state.auth,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role === "superadmin" && !isInstalled) {
      navigate("/installation");
    }
  }, [user, isInstalled, navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [clientInfo, setClientInfo] = useState(null);

  // Fetch client IP/location info
  useEffect(() => {
    async function fetchIpInfo() {
      try {
        const res = await fetch("https://ipinfo.io/json");
        const data = await res.json();
        setClientInfo(data);
      } catch (err) {
        console.error("Failed to fetch IP info", err);
      }
    }
    fetchIpInfo();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password, clientInfo }));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo.png" alt="Microsite Cloud" className="login-logo" />
          <h3 className="login-title">Welcome Back</h3>
          <p className="login-subtitle">Sign in to your dashboard</p>
        </div>

        {error && (
          <div
            className="alert alert-danger d-flex align-items-center"
            role="alert"
          >
            <small>{error}</small>
          </div>
        )}

        {loginAttempts >= 3 && (
          <div
            className="alert alert-warning d-flex align-items-center"
            role="alert"
          >
            <small>Too many failed attempts! Please try again later.</small>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Email address</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@company.com"
              required
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex="-1"
              >
                {showPassword ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-login w-100"
            disabled={loading || loginAttempts >= 3}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Signing in...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>

        <div className="login-footer">
          <div className="ip-info">
            <MdComputer size={14} />
            <span>{clientInfo?.ip || "Loading IP..."}</span>
            {clientInfo?.city && (
              <>
                <span className="mx-1">•</span>
                <MdLocationOn size={14} />
                <span>
                  {clientInfo.city}, {clientInfo.country}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
